export default {
  slots: {
    itemTrailing: 'gap-0.5',
    item: 'cursor-pointer',
    trailingIcon: 'shrink-0 text-(--ui-text)',
  },
  variants: {
    size: {
      sm: {
        item: 'gap-0.5',
      },
    },
  },
}